import React, { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Report from './Report/Report';
import Enroll from './Enroll/Enroll';
import Terms from './Terms/Terms';
import Questions from './Questions/Questions';
import EnrollForm from '../components/EnrollForm/EnrollForm';
import Pending from './Pending/Pending';
import Rejected from './Rejected/Rejected';
import Error from './Error/Error';
import { enrollmentStatusSelector, reportSelector } from './ReportsSelector';
import { isEnrollModalOpenSelector, isFetchingReportSelector } from '../ExperianSelector';
import { ENROLLMENT_STATUS } from '../ExperianConstants';
import { fetchReport, setIsEnrollModalOpen } from '../ExperianActions';
import LoadingView from './Report/LoadingView/LoadingView';
import ExperianContext from '../ExperianContext';

const Reports = () => {
  const isEnrollModalOpen = useSelector(isEnrollModalOpenSelector);
  const report = useSelector(reportSelector);
  const enrollmentStatus = useSelector(enrollmentStatusSelector);
  const isFetchingReport = useSelector(isFetchingReportSelector);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();
  const closeEnrollModal = useCallback(() => dispatch(setIsEnrollModalOpen(false)), [dispatch]);

  useEffect(() => {
    if (!report && subscriberId !== '0') {
      dispatch(fetchReport(clientId, subscriberId));
    }
  }, [clientId, subscriberId, report, dispatch]);

  if (isFetchingReport) {
    return <LoadingView />;
  }

  return (
    <>
      {(() => {
        switch (enrollmentStatus) {
          case ENROLLMENT_STATUS.NONE:
            return <Enroll />;
          case ENROLLMENT_STATUS.ERROR:
            return <Error />;
          case ENROLLMENT_STATUS.ENROLLED:
            return <Terms />;
          case ENROLLMENT_STATUS.ENROLLED_AND_ACCEPTED_TERMS:
            return <Questions />;
          case ENROLLMENT_STATUS.PENDING_VERIFICATION:
            return <Pending />;
          case ENROLLMENT_STATUS.AUTHENTICATED:
            return <Report report={report} />;
          case ENROLLMENT_STATUS.REJECTED:
            return <Rejected />;
          case ENROLLMENT_STATUS.NOT_ACTIVE:
            return <Pending>Your cancellation is pending. Please check back later.</Pending>;
          default:
            return null;
        }
      })()}

      <EnrollForm isOpen={isEnrollModalOpen} onCancel={closeEnrollModal} />
    </>
  );
};

export default Reports;
